export default __webpack_public_path__ + "static/media/img-12.588f6b4d.jpg";